import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { QuotaList } from "./list";
import { QuotaDetail } from "./detail";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

const QuotaRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<QuotaList />} />
        <Route path={`:idName/*`} element={<QuotaDetail />} />
      </Routes>
    </Layout>
  );
};

export default QuotaRoute;
